export default function Button({ label, onClick, stage }) {
    return (
        <button className="btn btn--outline test__button" onClick={() => onClick(stage, label)} type="button">
            {label}
        </button>
    )
}